export type ViolationType = 'WARNING' | 'MUTE' | 'KICK' | 'BAN' | 'MESSAGE_DELETED';
export type ViolationContext = 'CHAT' | 'GAME' | 'GLOBAL';

export interface ViolationWithDetails {
  id: number;
  userId: number;
  violationType: ViolationType;
  context: ViolationContext;
  contextEntityId: number | null;
  relatedMessageId: number | null;
  reason: string;
  duration: number | null;
  expiresAt: string | null;
  adminId: number;
  isActive: boolean;
  revokedAt: string | null;
  revokedByAdminId: number | null;
  revokeReason: string | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: number;
    firstName: string | null;
    lastName: string | null;
    username: string | null;
  } | null;
  admin: {
    id: number;
    email: string;
    username: string;
  } | null;
  revokedByAdmin: {
    id: number;
    email: string;
    username: string;
  } | null;
}

export interface ViolationStats {
  totalViolations: number;
  activeViolations: number;
  byType: Record<string, number>;
}

export const VIOLATION_TYPE_LABELS: Record<ViolationType, string> = {
  WARNING: 'Предупреждение',
  MUTE: 'Мут',
  KICK: 'Исключение',
  BAN: 'Бан',
  MESSAGE_DELETED: 'Удаление сообщения',
};

export const VIOLATION_TYPE_COLORS: Record<ViolationType, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  WARNING: 'outline',
  MUTE: 'secondary',
  KICK: 'default',
  BAN: 'destructive',
  MESSAGE_DELETED: 'secondary',
};

export const VIOLATION_CONTEXT_LABELS: Record<ViolationContext, string> = {
  CHAT: 'Чат',
  GAME: 'Игра',
  GLOBAL: 'Глобально',
};
